var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticStyle:{"padding":"20px"},attrs:{"href":_vm.anchor}},[_c('div',{staticClass:"topo-ead-v",style:({ color: _vm.cor })})])}
var staticRenderFns = []

export { render, staticRenderFns }